import React from 'react';
import type { Image as ImageType } from '../../commonTypes/image';
import { GridItem } from '../Grid';
import Image from '../Image';
import {
  DesktopOnlyGridItem,
  ImageGalleryGrid,
  MobileGridItem,
  MobileScrollableWrapper,
  TabletOnlyGridItem,
} from './styles';

type ImageGalleryProps = {
  images: ImageType[];
};

const ImageGallery: React.FC<ImageGalleryProps> = ({ images }) => {
  const tabletImageList = images.slice(0, 2);

  const DesktopImageGallery = images.map((image, index) => (
    <DesktopOnlyGridItem key={`Image${index}`} desktop={4} tabletLandscape={4}>
      <Image image={image} />
    </DesktopOnlyGridItem>
  ));

  const TabletImageGallery = tabletImageList.map((image, index) => (
    <TabletOnlyGridItem key={`Image${index}`} tabletPortrait={4}>
      <Image image={image} />
    </TabletOnlyGridItem>
  ));

  const MobileImageGallery = (
    <MobileScrollableWrapper data-cy="Mobile-image-gallery">
      <MobileGridItem mobile={9}>
        {images.map((image, index) => (
          <GridItem key={`Image${index}`} mobile={3}>
            <Image image={image} />
          </GridItem>
        ))}
      </MobileGridItem>
    </MobileScrollableWrapper>
  );

  return (
    <ImageGalleryGrid data-cy="Image-gallery">
      {DesktopImageGallery}
      {TabletImageGallery}
      {MobileImageGallery}
    </ImageGalleryGrid>
  );
};

export default ImageGallery;
